import { AxiosInstance } from 'axios';

import { WidgetDTO } from '@topconagriculture/dashboard/build/api/widget/widget.types';

const DashboardServiceFactory = ({ HTTPBase }: { HTTPBase: AxiosInstance }) => {
  return {
    getWidgetList: (userId: string): Promise<WidgetDTO[] | ''> => {
      // returns empty string with 204 status
      return HTTPBase.get(`/user-settings/${userId}/dashboard`).then((res) => res.data);
    },
  };
};

export default DashboardServiceFactory;
